

























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PaymentFailedModalComponent extends Vue {
  public $refs!: {
    modal: any;
  };

  @Prop(String) public readonly id!: string;
  @Prop(Array) public readonly paymentErrors!: string[];

  private get errorMessage() {
    const genericMessage =
      'Your payment has failed, please retry by clicking below link';
    const paymentDetails =
      'Your payment method was declined, please verify the payments details you entered and try again';

    if (this.paymentErrors.includes('Purchase failed.')) {
      return paymentDetails;
    }
    return genericMessage;
  }

  private close() {
    this.$refs.modal.hide();
  }
}
